<template>
  <el-tooltip v-if="isEnabled">
    <template #content>
      <div
        v-if="props.image"
        class="overflow-hidden rounded-lg mb-2"
      >
        <img
          :src="props.image"
          :alt="props.text"
          loading="lazy"
        >
      </div>
      <p>
        {{ props.text }}
      </p>
    </template>
    <button
      :class="$attrs.class"
      type="button"
    >
      <Icon
        name="help-circle"
        class="w-4 h-4 transition text-gray-400 hover:text-gray-500"
      />
    </button>
  </el-tooltip>
</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    default: null,
  },
});

// Refs
const isEnabled = ref(false);

// Lifecycle
onMounted(() => {
  if (import.meta.client) {
    isEnabled.value = true;
  }
});
</script>
